import { ChevronDown, ChevronLeft, ChevronRight, CircleCheck, Clock3, PhoneCall, ShieldCheck, Sparkles, TrendingUp, Waves, X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { publicApi } from '../../api/client';
import LazyYouTube from '../../components/LazyYouTube/LazyYouTube';

import './Home.css';

/* ═══════════════════════════════════════════════════════
   ALL STATIC DATA – không cần API
═══════════════════════════════════════════════════════ */

const HERO_V2 = {
  collage: ['https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882449/M%E1%BA%ABu_t%C3%A2y_1_koqhsd.jpg', 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882449/M%E1%BA%ABu_t%C3%A2y_2_ixj7zh.jpg'],
  thumbs: [
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882449/M%E1%BA%ABu_t%C3%A2y_1_koqhsd.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882449/M%E1%BA%ABu_t%C3%A2y_2_ixj7zh.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882450/M%E1%BA%ABu_t%C3%A2y_3_y83m50.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882581/2_ykvu3v.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882581/1_cycrqg.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774882581/3_fqxazt.jpg',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775711579/Copilot_20260409_121140_ouexox.png',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775711737/Copilot_20260409_121516_ny0ygv.png',
    'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775711970/Copilot_20260409_121909_g3fzbw.png',

  ],
  bullets: [
    'Vẫn dùng mỹ phẩm cũ nhưng đột nhiên hiệu quả lại tốt hơn gấp 7 lần',
    'Trước kia trị nám mất cả năm, giờ rút gọn chỉ còn 2 tháng',
    'Trẻ hóa da cao cấp như tại spa nhưng giá chỉ bằng 1/5',
    'Mua 1 mà được 10 sản phẩm chăm sóc da toàn diện',
  ],
  plans: [
    {
      key: '3m',
      title: 'Liệu trình 3 tháng',
      sub: '(Tặng 1 serum trẻ hóa fullsize 30ml)',
      oldPrice: '$741',
      price: '$540',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775364686/3_h%E1%BB%99p_n70zi2.png',
      imgRight: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775364683/SEP04218_1_vhnfba.png',
    },
    {
      key: '2m',
      title: 'Liệu trình 2 tháng',
      sub: '(Tặng 1 mặt nạ ngủ)',
      oldPrice: '$494',
      price: '$360',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365244/2_h%E1%BB%99p_jja3if.png',
      imgRight: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365270/SEP04123_je5o4j.png',
    },
    {
      key: '1m',
      title: 'Liệu trình 1 tháng',
      sub: '',
      oldPrice: '',
      price: '$247',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365244/2_h%E1%BB%99p_jja3if.png',
    },
  ],
};

const HERO_V2_EN = {
  bullets: [
    'Still using the same skincare products, but suddenly their effectiveness becomes 7 times better.',
    'Melasma used to take a whole year—now it’s down to 2 months',
    'Spa-grade premium rejuvenation at just 1/5 the price',
    'Buy 1 and receive 10 full skincare products',
  ],
  plans: [
    {
      key: '3m',
      title: '3-Month Treatment',
      sub: '(Free 1 full-size 30ml anti-aging serum)',
      oldPrice: '$741',
      price: '$540',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775364686/3_h%E1%BB%99p_n70zi2.png',
      imgRight: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775364683/SEP04218_1_vhnfba.png',
    },
    {
      key: '2m',
      title: '2-Month Treatment',
      sub: '(Free 1 sleeping mask)',
      oldPrice: '$494',
      price: '$360',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365244/2_h%E1%BB%99p_jja3if.png',
      imgRight: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365270/SEP04123_je5o4j.png',
    },
    {
      key: '1m',
      title: '1-Month Treatment',
      sub: '',
      oldPrice: '',
      price: '$247',
      imgLeft: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775365244/2_h%E1%BB%99p_jja3if.png',
    },
  ],
};

/** Banner 2 ảnh + 4 khối sản phẩm (layout như mẫu hình 2) */
const KIT_SHOWCASE = {
  banners: [
    { src: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883154/SEP04176_1_fynskm.jpg', alt: 'Bộ kit AuraGlow microneedle' },
    { src: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883154/SEP04173_k3oyoj.jpg', alt: 'Bộ kit AuraGlow — góc nhìn khác' },
  ],
  blocks: [
    {
      key: 'roller',
      label: 'CÂY LĂN Y TẾ 0.5MM',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883204/C%C3%A2y_l%C4%83n_y_t%E1%BA%BF_2_tujev6.png',
    },
    {
      key: 'serum-aging',
      label: 'SERUM TRẺ HÓA ANTI-AGING',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883203/Serum_tr%E1%BA%BB_h%C3%B3a_anti-aging_u2kpid.png',
    },
    {
      key: 'serum-whitetea',
      label: 'SERUM PHỤC HỒI WHITE TEA',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883202/Serum_ph%E1%BB%A5c_h%E1%BB%93i_white_tea_fb9x8k.png',
    },
    {
      key: 'mask',
      label: 'MẶT NẠ NGỦ',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883205/M%E1%BA%B7t_n%E1%BA%A1_ng%E1%BB%A7_bxn5dt.png',
    },
  ],
};

const KIT_SHOWCASE_EN = {
  banners: [
    { src: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883154/SEP04176_1_fynskm.jpg', alt: 'AuraGlow microneedle kit' },
    { src: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883154/SEP04173_k3oyoj.jpg', alt: 'AuraGlow kit — different angle' },
  ],
  blocks: [
    {
      key: 'roller',
      label: 'MEDICAL ROLLER 0.5MM',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883204/C%C3%A2y_l%C4%83n_y_t%E1%BA%BF_2_tujev6.png',
    },
    {
      key: 'serum-aging',
      label: 'ANTI-AGING SERUM',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883203/Serum_tr%E1%BA%BB_h%C3%B3a_anti-aging_u2kpid.png',
    },
    {
      key: 'serum-whitetea',
      label: 'WHITE TEA RECOVERY SERUM',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883202/Serum_ph%E1%BB%A5c_h%E1%BB%93i_white_tea_fb9x8k.png',
    },
    {
      key: 'mask',
      label: 'SLEEPING MASK',
      img: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883205/M%E1%BA%B7t_n%E1%BA%A1_ng%E1%BB%A7_bxn5dt.png',
    },
  ],
};



const FEEDBACK_IMGS = [
  'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671785/fb1_pgyzwn.png', 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671787/fb2_girv6v.png', 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671785/fb3_aa9c2e.png',
  'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671786/fb4_ypqtuo.png', 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671787/fb5_ovrik6.png', 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto,w_600/v1774671787/fb6_ozqy5a.png',
  "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194846/3.1.7_bij533.png", "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194846/3.1.8_avnek2.png", "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194847/3.1.10_j14co9.png", "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194847/3.1.9_aqq8gl.png"
];

const FEEDBACK_V2_SLIDES = [
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774884004/2.3_htyaqu.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774884005/2.1_pzus5t.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774884005/2.2_jos3lf.jpg',
  "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194301/1.7_gcgaf8.jpg",
  "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194301/1.8_nawves.jpg",
  "https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775194301/1.9_mlfnnd.jpg",
]

const FEEDBACK_V2_STATS = [
  {
    percent: '96%',
    text: 'Khẳng định serum, kem dưỡng hiệu quả hơn sau khi dùng kết hợp với lăn kim AuraGlow.',
  },
  {
    percent: '93%',
    text: 'Nhận thấy làn da thay đổi ngay ngày hôm sau, sau lần lăn kim đầu tiên.',
  },
  {
    percent: '85%',
    text: 'Cho biết nếp nhăn mờ đi trông thấy, da căng bóng, đàn hồi hơn.',
  },
  {
    percent: '77%',
    text: 'Nói rằng da trở nên sáng hơn, đều màu hơn, mờ nám sạm.',
  },
];

const FEEDBACK_V2_STATS_EN = [
  {
    "percent": "96%",
    "text": "Confirmed that serums and moisturizers become more effective when used in combination with the AuraGlow microneedling roller."
  },
  {
    "percent": "93%",
    "text": "Noticed visible skin improvement as early as the next day after the first microneedling session."
  },
  {
    "percent": "85%",
    "text": "Reported visibly reduced wrinkles, with firmer and more elastic skin."
  },
  {
    "percent": "77%",
    "text": "Said their skin became brighter, more even-toned, and dark spots appeared faded."
  },
];

// Feedback blocks: desktop 3 thẻ/trang; mobile 1 ảnh/slide (cùng mũi tên + chấm)
const FEEDBACK_CARDS_PER_PAGE = 3;
const FEEDBACK_IMGS_LEN = FEEDBACK_IMGS.length;
const FEEDBACK_CARDS_PAGE_COUNT = Math.ceil(FEEDBACK_IMGS_LEN / FEEDBACK_CARDS_PER_PAGE);



/** Video khách tại nhà — YouTube Shorts */
const CUSTOMER_HOME_VIDEOS = [
  'IXMMuy08dEg',
  '28oAl1mbnZA',
  'qqln4L0t23Q',
  '6e7cVLaCZ8Q',
  'PPt5OpEFHh8',
  '3aW5lOaWRe8',
];

// Review avatars
const RB_AVATAR_URLS = [
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195656/c9e3f3eb605f8ccb06b5d2f076db6916_y97j0i.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/hinh-anh-con-gai-dang-yeu_050954225_wkdbki.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/cuoc-song-vang-thi-sinh-14-ngoisaovn-w1152-h2048_wgflsr.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/hinh-gai-k7-k8-2k7-2k8-cuc-xinh_xiora2.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/OIP_2_jotzpx.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/hinh-anh-gai-xinh-cap-2-3_hl7cqe.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195658/OIP_3_nsjp40.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195657/OIP_1_vb74kk.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195658/OIP_4_w4ojxm.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195658/monbiebs_38640368_208146230059182_5551942968992071680_n_ob7ub9.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195659/OIP_w8dplm.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto,w_150/v1775195659/OIP_qtdsmr.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195660/u_3338544639_2161442728_fm_253_gp_0_a2wjbi.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195660/1692105084-dan-hot-girl-lai-tay-mang-den-net-dep-dac-trung-kho-nham-lan-hinh-3-width600height800_glhvhz.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195661/2f4f447451fd4ab0767c1bfaff9165e0_acsiz0.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195660/Tran-Thanh-Ngoc_okr5qc.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195661/606760e8627d28793cb7fafed7bdd894_phgzhb.jpg',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195662/avatar-con-gai-cute-1_skfxgp.webp',
  'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775195662/b15744005566c4ace1a2d9420ec94c2a_tnbrlq.jpg',
];

// Review list
const RB_REVIEWS = [
  {
    name: 'Nhật Lệ',
    stars: 5,
    highlight: 'Work từ lần đầu',
    text: 'Lúc đầu mình khá lo vì chưa từng thử lăn kim, nhưng bộ AuraGlow dễ dùng hơn mình nghĩ. Mỗi tuần chỉ làm 1 lần mà da mịn, sáng lên rõ. Mình dùng chung với serum cũ thấy da căng bóng hơn, trắng hơn nhiều đó',
  },
  {
    name: 'Jessi',
    stars: 5,
    highlight: 'Da khỏe trông thấy',
    text: 'Da mình thuộc loại dễ bị nám lại sau mỗi đợt nắng nhiều. Sau 2 tháng kiên trì lăn kim với bộ này, nám mờ hẳn, mà quan trọng là da khỏe hơn, ít bắt nắng hơn.',
  },
  {
    name: 'Thu Uyen Tran',
    stars: 5,
    highlight: 'Tiết kiệm, hiệu quả, đáng thử',
    text: 'Không ngờ có thể tự chăm sóc da tại nhà mà vẫn có hiệu quả giống đi spa. Mình dùng được 6 tuần, da đều màu và bóng mượt. Cảm giác da căng hơn liền sau khi lăn kim. Nếp nhăn nhỏ nhỏ cũng mờ hết rồi, da mịn mướt lắm đó',
  },
  {
    name: 'Andrea Nguyen',
    stars: 5,
    highlight: 'Work, tôi rất thích',
    text: 'Chất lượng sản phẩm rất tốt, hướng dẫn rõ ràng. Work. da sáng, đều màu, nhìn kiểu healthy glow á. Da mình giờ apply serum thấy thấm liền, không còn nằm nhớt trên da như trước nữa.',
  },
  {
    name: 'Trang Vu',
    stars: 5,
    highlight: 'Sẽ mua thêm và giới thiệu',
    text: 'Trước giờ cứ đổi mỹ phẩm liên tục mà da vẫn xỉn, dùng bộ lăn kim này kết hợp với routine cũ lại thấy hiệu quả rõ. Rất refresh. Like, mình còn tưởng chắc phải đi clinic mới được vậy. Nhất định sẽ mua lại.',
  },
  {
    name: 'Blair Vũ',
    stars: 5,
    highlight: 'i love AuraGlow',
    text: 'Mình hơn 50. Da vừa nhăn vừa chảy xệ rồi. Xài AuraGlow 2 month, da căng, nâng cơ, it’s work.Người khác nhìn cũng hỏi mình đi làm đẹp ở đâu. i love AuraGlow',
  },
  {
    name: 'Hoàng Uyên Nhi',
    stars: 5,
    highlight: 'i don\'t feel any pain',
    text: 'Tôi từng điều trị nám laser nhưng không duy trì được lâu. Lăn kim tại nhà tiết kiệm, chủ động. And i don\'t feel any pain. đốm đen mờ, sáng da, trắng lên',
  },
  {
    name: 'Thùy Dung',
    stars: 5,
    highlight: 'Kết quả vượt mong đợi',
    text: 'Lúc đầu cũng nghi ngờ lắm, tại da mình dưỡng hoài mà vẫn khô, nám cứ lấm tấm hoài không hết. Ai ngờ lăn bộ này thấy da mịn hơn, sáng nhẹ mà đều màu ra liền. Thích nhất là serum thấm cực nhanh sau khi lăn, da như hút vô luôn á. Mấy chỗ nám đậm bắt đầu mờ đi thấy rõ, bôi kem chống nắng cũng đẹp. Giờ ai gặp cũng khen da khoẻ với tươi, mình thấy vui dễ sợ luôn.',
  },
  {
    name: 'Thúy Quỳnh',
    stars: 5,
    highlight: 'an toàn cho da',
    text: 'Da tôi bị nhạy cảm với nhiều sản phẩm, nhưng lăn kim AuraGlow dùng vẫn thấy êm. Không bị kích ứng, không nổi mụn, da chỉ hơi ửng đỏ nhẹ rồi hết sau vài giờ. Da ẩm hơn, căng hơn, nhăn râu rồng mờ hẳn',
  },
  {
    name: 'Hằng Lê Thu',
    stars: 5,
    highlight: '',
    text: 'Cảm giác cầm cây lăn chắc tay, đầu kim nhỏ, lăn không đau. Giao hàng nhanh, đóng gói kỹ. Đã giới thiệu cho mẹ và bạn bè cùng dùng thử, ai cũng bất ngờ vì hiệu quả rõ sau vài tuần.',
  },
  {
    name: 'Anna Nga Huỳnh',
    stars: 5,
    highlight: '',
    text: 'Trước giờ chỉ nghe tới lăn kim ở spa, không ngờ ở nhà cũng làm được. Bộ này dễ xài, không đau, mà hiệu quả rõ rệt. Mình xài đều 2 tháng nay, da sáng hơn, mấy vết nám mờ nhiều. Highly recommend',
    afterTextThumb: [
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775185854/8.1_zrjcox.jpg',
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775185854/8.1_zrjcox.jpg', /* Link hình 2 */
    ],
  },
  {
    name: 'Alen Hoài',
    stars: 5,
    highlight: '',
    text: 'Tôi gần 60 rồi, nhiều nhăn, với chảy xệ, mà không ngờ araglo hiệu quả thế. trông cũng tươi tre hơn như hồi xuân. Không được đẹp như lớp trẻ nhưng cải thiện tốt. Tôi làm đều đặn 1 tuần 1 lần, chuyên viên chăm sóc kĩ, đáng đồng tiền bát gạo',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186370/5.12_qmlpgt.jpg',
  },
  {
    name: 'Georgina J',
    stars: 5,
    highlight: '',
    text: 'This at-home microneedling kit is a total game changer. I used to spend $$$ at facial spas, now I can get that same glow from home. My pigmentation is fading and I feel more confident',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186434/5.13_gcgosq.jpg',
  },
  {
    name: 'Stacy H',
    stars: 5,
    highlight: '',
    text: 'After turning 40, I noticed my skin started to look dull and tired. Since using AuraGlow, my face looks fresher, tighter, and more radiant. Even my husband noticed — and he never notices anything skincare-related',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186491/5.14_fxudss.jpg',
  },
  {
    name: 'Vân A.',
    stars: 5,
    highlight: 'Không ngờ tuổi này mà da vẫn cải thiện được',
    text: 'Cô thuộc tuýp da khô, nhăn nheo, đặc biệt ở cổ và má. Ban đầu dùng AuraGlow chỉ nghĩ thử thôi chứ không mong gì nhiều. Nhưng đến tuần thứ 2 đã thấy khác – da bắt đầu căng nhẹ, sờ vào không còn thô ráp. Tới tuần thứ 5, da sáng hơn, các rãnh cười không còn sâu nữa. Cô thấy mình rạng rỡ hẳn, nhìn trong gương tự tin hơn rất nhiều.',
    afterTextThumb: [
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186566/94_5_fdladw.jpg',
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186569/94_6_i6daqe.png'
    ],
  },
  {
    name: 'Kim P.',
    stars: 5,
    highlight: 'Tàn nhang li ti mờ dần rồi biến mất',
    text: 'Chị có làn da trắng nhưng bị tàn nhang rất nhiều, chủ yếu do di truyền và nắng. Từng nghĩ chỉ có laser mới xử lý được. Nhưng khi thử AuraGlow, chị thấy da cải thiện dần đều. Lúc đầu không rõ lắm, nhưng tới tuần thứ 4 thì nhiều đốm li ti mờ hẳn. Da đều màu, sáng khoẻ, không bị đỏ rát gì cả. Quan trọng là chị tự làm được ở nhà, không mất thời gian đi lại.',
  },
  {
    name: 'Hồng L.',
    stars: 5,
    highlight: '"Không cần tiêm, da vẫn căng bóng!"',
    text: 'Da mình trước đây bị chảy xệ, đặc biệt là vùng quai hàm và bọng mắt. Nhìn nghiêng thấy rõ luôn. Dù đã thử nâng cơ bằng sóng RF ở spa vài lần nhưng hiệu quả không duy trì lâu. Sau 1 liệu trình AuraGlow, mình thật sự bất ngờ. Da không chỉ căng mà còn săn lại, gọn mặt hơn, lỗ chân lông cũng nhỏ hẳn. Đặc biệt là vùng quanh mắt, nếp nhăn li ti mờ rõ rệt. Dùng tại nhà mà cảm giác như vừa làm liệu trình trẻ hóa da chuyên sâu ở clinic.',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186700/5.17_jeuqtk.jpg',
  },
  {
    name: 'Hoàng Y.',
    stars: 4,
    highlight: 'Da căng thật, nhưng hơi rát lúc đầu',
    text: 'Lần đầu dùng cũng hơi lo, vì da tôi mỏng và hay kích ứng. Khi lăn kim AuraGlow lần đầu thì hơi châm chích, khoảng 1 ngày là hết. Qua đến lần thứ 2 thì thấy đỡ hơn nhiều. Da bắt đầu có độ căng, không còn bong tróc vùng khóe miệng nữa. Vẫn đang dùng tiếp để theo dõi thêm nhưng đến giờ thì khá hài lòng.',
  },
  {
    name: 'Megan T.',
    stars: 5,
    highlight: '“I wasn’t expecting this much improvement!”',
    text: 'I have very sensitive skin with freckles and mild melasma from years of sun exposure in California. I was worried microneedling at home would irritate my skin, but AuraGlow turned out to be gentle yet effective. After the third week, the freckles around my cheeks looked lighter, and the texture of my skin felt much smoother. I use it once a week with hyaluronic serum, and my skin now has a healthy glow. I’m sticking with it for sure!',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186756/5.19_ny0oxr.jpg',
  },
  {
    name: 'Hồng P.',
    stars: 5,
    highlight: 'Da sáng, mờ nám – quá ưng!',
    text: 'Tôi 47 tuổi, định cư tại Pháp. Da tôi trước đây bị sạm, có vài nốt nám rải rác do nội tiết và tuổi tác. Tôi được bạn giới thiệu AuraGlow nên quyết định thử. Sau 4 tuần chăm chỉ dùng thì vùng nám bên má trái gần như mờ hẳn, da đều màu, sáng hơn và nhìn khỏe hơn nhiều. Giờ ra đường chỉ cần thoa chút kem chống nắng là đủ tự tin.',
    afterTextThumb: [
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186824/23_4_oyl3w6.jpg',
      'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186822/23_3_u0hwvc.jpg'
    ]
  },
  {
    name: 'Ms. Sarah L.',
    stars: 4,
    highlight: 'Love how it boosts my skincare',
    text: 'I’ve been using the same Korean essence for years, but it never really penetrated. After I added AuraGlow microneedling, I noticed my skin absorbs products way better. Skin feels more “alive” in the morning. Took 3 sessions to see results though. Slight redness after use, but it fades fast.',
  },
  {
    name: 'Phương H.',
    stars: 4,
    highlight: 'Không phải sản phẩm thần kỳ, nhưng rất đáng thử!',
    text: 'Tôi vẫn dùng kem dưỡng SK-II của mình, không thay gì cả. Chỉ thêm bước lăn kim AuraGlow mỗi tuần 1 lần. Sau 1 tháng thì rõ ràng da đều màu hơn, vùng quanh miệng không bị xám nữa, nếp nhăn cũng bớt sâu. Duy chỉ có điều hơi lích kích nếu hôm nào về mệt quá muốn đi nằm luôn.',
  },
  {
    name: 'Giang N.',
    stars: 5,
    highlight: '',
    text: 'Không nghĩ là lăn kim xài tiện vậy luôn. Mình muốn đi spa lắm nhưng chẳng có điều kiện mà giờ biết là lăn kim cũng xài được tại nhà vậy chẳng cần đi đâu cho khỏe. Không phải kiêng cữ gì cả thoải mái lắm',
  },
  {
    name: 'Thu H.',
    stars: 5,
    highlight: '',
    text: 'Bao nhiêu là quà luôn. Mua trúng đợt khuyến mãi nên quà tặng nhiều ngang đồ mua rồi',
  },
  {
    name: 'Linh N.',
    stars: 4,
    highlight: 'Có tác dụng thật, nhưng phải kiên trì',
    text: 'Mình đã dùng AuraGlow chung với serum vitamin C quen thuộc. Sau 3 buổi đầu thấy chưa khác nhiều, nhưng từ tuần thứ 2 trở đi thì da bắt đầu sáng hơn, vết thâm cũ mờ dần. Da cũng không còn bong tróc như trước. Trừ việc đầu kim hơi nhạy cảm với da mình lần đầu, còn lại mọi thứ đều ổn.',
  },
  {
    name: 'Đan T.',
    stars: 4,
    highlight: '',
    text: 'Mình có thói quen dùng mỹ phẩm hữu cơ từ châu Âu, nên ban đầu hơi lo khi dùng thêm AuraGlow. Sau lần đầu da hơi đỏ và ngứa nhẹ, nhưng kết hợp thêm kem phục hồi thì ổn ngay. Sau 3 tuần dùng đều, da bớt khô, các vết nám nhỏ mờ hẳn. Không quá “thần tốc”, nhưng nếu chăm chỉ thì thấy rõ từng chút thay đổi',
    afterTextThumb: 'https://res.cloudinary.com/difvdzr4l/image/upload/f_auto,q_auto/v1775186907/5.26_of8zke.jpg',
  },
  {
    name: 'Minh T.',
    stars: 4,
    highlight: 'Tốt nhưng cần kiên trì và dưỡng kỹ sau đó',
    text: 'Da mình có nhiều đốm nâu và hơi mỏng, lại dùng retinol nên ban đầu hơi lo. Nhưng thử AuraGlow kết hợp với kem phục hồi cũ thì ok, không bị đỏ nhiều. Sau 4 tuần da sáng hơn, các đốm nhỏ mờ dần. Tuy không "thay da" rõ rệt như đi spa, nhưng cảm nhận da khỏe hơn thật sự. Nếu ai đang dùng sản phẩm active như mình thì nhớ dưỡng kỹ sau mỗi lần lăn nha.',
  },
  {
    name: 'Isabelle R.',
    stars: 5,
    highlight: 'Visible glow and tighter skin',
    text: 'I noticed a huge improvement in skin texture after just two sessions. My pores look smaller, and my cheeks feel firmer – like a natural lift. The glow is real, and my foundation sits so much better now. Definitely sticking with this routine.',
  },
  {
    name: 'Thuỳ T.',
    stars: 4,
    highlight: '',
    text: 'Mới lăn lần đầu thấy hơi châm chích nhẹ nhưng ngày hôm sau da bắt đầu căng hơn hẳn. Tôi kết hợp với kem dưỡng cũ”, da sáng lên và mềm hơn rất nhiều. Trừ 1 sao vì tinh chất được ít quá, hi vọng được tặng thêm white tea',
  },
  {
    name: 'Kate R.',
    stars: 5,
    highlight: 'Softer skin and faded freckles',
    text: 'I’m in my early 40s and had mild sunspots and visible pores. After using AuraGlow’s microneedling system for about a month, I’ve noticed significant improvement – my skin feels smoother, fresher, and the tiny freckles on my nose have lightened a lot. The serum feels premium, and the roller is surprisingly easy to use. I’ll definitely repurchase.',
  },
];



/** So sánh 3 cột — thay bảng 4 cột cũ (layout như hình 2/3) */
const COMPARE_V2 = {
  title: 'Tại sao lăn kim AuraGlow lại khác biệt?',
  rollerImg: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883204/C%C3%A2y_l%C4%83n_y_t%E1%BA%BF_2_tujev6.png',
  auraHead: 'Kết hợp mỹ phẩm với lăn kim AuraGlow',
  cosHead: 'Chỉ sử dụng mỹ phẩm',
  rows: [
    {
      label: 'Khả năng thẩm thấu dưỡng chất',
      aura: (
        <>
          Tăng mạnh nhờ tạo &ldquo;kênh dẫn&rdquo; qua vi điểm siêu nhỏ trên da, da nhận được <strong>100% dưỡng chất</strong>
        </>
      ),
      cos: 'Hạn chế do lớp sừng trên da cản trở, da chỉ nhận được 10-15%',
    },
    {
      label: 'Tốc độ cải thiện làn da',
      aura: 'Nhanh hơn, thấy rõ sau 3–4 lần sử dụng.',
      cos: 'Từ từ, cần kiên trì trong thời gian dài.',
    },
    {
      label: 'Hiệu quả trên các vấn đề da khó',
      aura: 'Cải thiện rõ rệt nhờ kích thích collagen & tái tạo tế bào mới.',
      cos: 'Kém hiệu quả với nám, sẹo rỗ, lỗ chân lông to.',
    },
    {
      label: 'Tần suất thực hiện',
      aura: 'Lăn kim 1 lần/tuần.',
      cos: 'Sử dụng hằng ngày.',
    },
    {
      label: 'Kết cấu da sau 1-2 tháng',
      aura: 'Da mịn hơn, săn chắc, đều màu, giảm nếp nhăn và thâm nám.',
      cos: 'Có thể thay đổi nhẹ.',
    },
    {
      label: 'Phù hợp với ai?',
      aura: 'Người muốn da cải thiện nhanh, muốn da trẻ đẹp hơn, giảm dấu hiệu lão hóa.',
      cos: 'Người muốn chăm sóc da cơ bản, da ít vấn đề.',
    },
  ],
};

const COMPARE_V2_EN = {
  title: 'Why is AuraGlow microneedling different?',
  rollerImg: 'https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1774883204/C%C3%A2y_l%C4%83n_y_t%E1%BA%BF_2_tujev6.png',
  auraHead: 'Combine skincare with AuraGlow microneedling',
  cosHead: 'Use skincare only',
  rows: [
    {
      label: 'Nutrient absorption',
      aura: (
        <>
          Boosted by creating “absorption pathways” through tiny micro-points in the skin, delivering{' '}
          <strong>100% of nutrients</strong>
        </>
      ),
      cos: 'Limited by the skin barrier—only about 10–15% is absorbed.',
    },
    {
      label: 'Skin improvement speed',
      aura: 'Faster—noticeable after 3–4 uses.',
      cos: 'Gradual—requires consistency over a long time.',
    },
    {
      label: 'Effect on stubborn skin concerns',
      aura: 'Clear improvement by stimulating collagen & regenerating new cells.',
      cos: 'Less effective for melasma, acne scars, and enlarged pores.',
    },
    {
      label: 'Treatment frequency',
      aura: 'Microneedling 1x per week.',
      cos: 'Daily use.',
    },
    {
      label: 'Skin texture after 1–2 months',
      aura: 'Smoother, firmer, and more even tone—reduces wrinkles and dark spots.',
      cos: 'May only bring slight changes.',
    },
    {
      label: 'Suitable for whom?',
      aura: 'For those who want faster improvement and younger-looking skin, with fewer aging signs.',
      cos: 'For those who need basic skincare with fewer concerns.',
    },
  ],
};

const PRESS_ROTATOR_ITEMS = [
  {
    key: 'vogue',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671792/British-Vogue-logo_jv6jos.png',
    quote:
      'Lăn kim vẫn là một trong những phương pháp tốt nhất giúp làn da được trẻ hóa tức thì và lâu dài mà gần như không cần thời gian nghỉ dưỡng.',
  },
  {
    key: 'newbeauty',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671794/New_Beauty_logo_ejcptj.png',
    quote:
      'Lăn kim giúp mở lớp rào chắn của da, tạo ra những lỗ siêu nhỏ trên da, cho phép các sản phẩm dưỡng da thẩm thấu sâu hơn.',
  },
  {
    key: 'marie',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671792/marie-claire_logo_jmllzt.png',
    quote:
      'Nếu bạn lăn kim đều đặn với loại serum phù hợp, bạn sẽ bắt đầu thấy kết quả sau vài tuần. Lăn càng nhiều, bạn càng rạng rỡ!',
  },
];

const PRESS_ROTATOR_ITEMS_EN = [
  {
    key: 'vogue',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671792/British-Vogue-logo_jv6jos.png',
    quote: 'Still one of the best ways to deliver instant and long‑term skin rejuvenation without any downtime.',
  },
  {
    key: 'newbeauty',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671794/New_Beauty_logo_ejcptj.png',
    quote: 'It opens up the skin barrier… microneedling creates little puncture sites in the skin, which allow for deeper product penetration.',
  },
  {
    key: 'marie',
    logoSrc: 'https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671792/marie-claire_logo_jmllzt.png',
    quote: 'If you keep a solid rolling regime with the right serums you will start seeing results in a couple of weeks. The more you roll, the more you glow!',
  },
];



const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8'];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? 'faq-item--open' : ''}`}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{q}</span>
        <ChevronDown
          className={`faq-chevron ${open ? 'faq-chevron--open' : ''}`}
          size={20}
          aria-hidden="true"
        />
      </button>
      <div className="faq-answer">
        <p>{a}</p>
      </div>
    </div>
  );
}

/* ─── Mini Components ─── */



/* ═══════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════ */
const Home = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language?.startsWith('en');

  const heroBullets = isEn ? HERO_V2_EN.bullets : HERO_V2.bullets;
  const heroPlans = isEn ? HERO_V2_EN.plans : HERO_V2.plans;
  const kitBanners = isEn ? KIT_SHOWCASE_EN.banners : KIT_SHOWCASE.banners;
  const kitBlocks = isEn ? KIT_SHOWCASE_EN.blocks : KIT_SHOWCASE.blocks;

  const feedbackStats = isEn ? FEEDBACK_V2_STATS_EN : FEEDBACK_V2_STATS;
  const rbReviews = RB_REVIEWS;
  const compareV2 = isEn ? COMPARE_V2_EN : COMPARE_V2;
  const pressItems = isEn ? PRESS_ROTATOR_ITEMS_EN : PRESS_ROTATOR_ITEMS;

  const [selectedPlan, setSelectedPlan] = useState('3m');
  const [selectedKit, setSelectedKit] = useState('roller');

  /* ── Booking modal state ── */
  const [showBooking, setShowBooking] = useState(false);
  const [bookingForm, setBookingForm] = useState({ fullName: '', phone: '', email: '', address: '' });
  const [bookingSubmitting, setBookingSubmitting] = useState(false);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [bookingError, setBookingError] = useState('');

  const PLAN_INFO = {
    '3m': { name_vi: 'Liệu trình 3 tháng', name_en: '3-Month Treatment', price: 540 },
    '2m': { name_vi: 'Liệu trình 2 tháng', name_en: '2-Month Treatment', price: 360 },
    '1m': { name_vi: 'Liệu trình 1 tháng', name_en: '1-Month Treatment', price: 247 },
  };

  const openBooking = () => {
    setBookingSuccess(false);
    setBookingError('');
    setShowBooking(true);
  };

  const closeBooking = () => {
    setShowBooking(false);
    setBookingError('');
  };

  const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setBookingSubmitting(true);
    setBookingError('');

    const plan = PLAN_INFO[selectedPlan];
    const planName = isEn ? plan.name_en : plan.name_vi;

    const payload = {
      full_name: bookingForm.fullName,
      phone: bookingForm.phone,
      email: bookingForm.email,
      address: bookingForm.address || 'N/A',
      items: [
        {
          product_id: null,
          product_name: `[Tư vấn] ${planName}`,
          quantity: 1,
          unit_price: plan.price,
          line_total: plan.price,
        },
      ],
      subtotal: plan.price,
      promo_code: '',
      discount: 0,
      total: plan.price,
      note: `Đặt lịch tư vấn - ${planName}`,
    };

    try {
      await publicApi.post('/api/orders/', payload);
      setBookingSuccess(true);
      setBookingForm({ fullName: '', phone: '', email: '', address: '' });
    } catch (err) {
      setBookingError(
        err?.response?.data?.detail || (isEn ? 'An error occurred. Please try again.' : 'Đã xảy ra lỗi. Vui lòng thử lại.')
      );
    } finally {
      setBookingSubmitting(false);
    }
  };
  const [kitCarouselIdx, setKitCarouselIdx] = useState(0);
  const [pressIdx, setPressIdx] = useState(0);

  const kitSlideCount = kitBanners.length + kitBlocks.length;
  const applyKitSlide = (targetIdx) => {
    const len = kitSlideCount;
    const idx = ((targetIdx % len) + len) % len;
    setKitCarouselIdx(idx);
    if (idx >= kitBanners.length) {
      const block = kitBlocks[idx - kitBanners.length];
      if (block) setSelectedKit(block.key);
    }
  };

  const mobKitBlock =
    kitCarouselIdx >= kitBanners.length ? kitBlocks[kitCarouselIdx - kitBanners.length] : null;
  const [feedbackIdx, setFeedbackIdx] = useState(0);
  const [feedbackCardsPage, setFeedbackCardsPage] = useState(0);
  const [feedbackMobileIdx, setFeedbackMobileIdx] = useState(0);
  const [feedbackBlocksMobile, setFeedbackBlocksMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches
  );
  const [heroImgIdx, setHeroImgIdx] = useState(0);
  const [customerVideoIdx, setCustomerVideoIdx] = useState(0);
  const [doctorVideoIdx, setDoctorVideoIdx] = useState(0);
  const customerMainVideoRef = useRef(null);

  /* ── Scroll reveal ── */
  useEffect(() => {
    const els = document.querySelectorAll('.sr');
    if (!els.length) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('sr-visible'); obs.unobserve(e.target); } }),
      { threshold: 0.12 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const iv = setInterval(() => {
      setPressIdx((p) => (p + 1) % PRESS_ROTATOR_ITEMS.length);
    }, 3000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    FEEDBACK_V2_SLIDES.forEach((src) => {
      const im = new Image();
      im.src = src;
    });
    FEEDBACK_IMGS.forEach((src) => {
      const im = new Image();
      im.src = src;
    });
  }, []);

  useEffect(() => {
    const iv = setInterval(() => {
      setFeedbackIdx((p) => (p + 1) % FEEDBACK_V2_SLIDES.length);
    }, 3000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    const v = customerMainVideoRef.current;
    if (!v) return;
    v.pause();
    v.currentTime = 0;
  }, [customerVideoIdx]);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 900px)');
    const apply = () => setFeedbackBlocksMobile(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  useEffect(() => {
    if (feedbackBlocksMobile) {
      if (FEEDBACK_IMGS_LEN <= 1) return;
      const iv = setInterval(() => {
        setFeedbackMobileIdx((p) => (p + 1) % FEEDBACK_IMGS_LEN);
      }, 7000);
      return () => clearInterval(iv);
    }
    if (FEEDBACK_CARDS_PAGE_COUNT <= 1) return;
    const iv = setInterval(() => {
      setFeedbackCardsPage((p) => (p + 1) % FEEDBACK_CARDS_PAGE_COUNT);
    }, 7000);
    return () => clearInterval(iv);
  }, [feedbackBlocksMobile]);

  return (
    <div className="home-page">

      {/* ═══════════════════════════
          1. HERO – Layout như hình 2
      ═══════════════════════════ */}
      <section className="hero-v2">
        <div className="container hero-v2__container">
          <div className="hero-v2__card">
            <div className="hero-v2__grid">
              {/* Left */}
              <div className="hero-v2__left">
                <div className="hero-v2__ratingBadge">
                  <span className="hero-v2__ratingStars" aria-hidden="true">★★★★<span className="hero-v2__starHalf">★</span></span>
                  <span className="hero-v2__ratingText">
                    {isEn ? '4.7/5 stars from customers' : '4.7/5 sao từ khách hàng'}
                  </span>
                </div>
                <h1 className="hero-v2__title">
                  <span>
                    {isEn ? '“The weapon” defeats the culprit' : '“Vũ khí” đánh bại thủ phạm'}
                  </span>
                  <span>{isEn ? 'that makes women use cosmetics' : 'khiến chị em dùng mỹ phẩm'}</span>
                  <span>{isEn ? 'for years yet skin stays dull' : 'bao năm da vẫn không đẹp'}</span>
                </h1>

                <ul className="hero-v2__bullets">
                  {heroBullets.map((txt, i) => (
                    <li key={i} className="hero-v2__bullet">
                      <span className="hero-v2__bulletIcon" aria-hidden="true">
                        <CircleCheck size={18} />
                      </span>
                      <span className="hero-v2__bulletText">{txt}</span>
                    </li>
                  ))}
                </ul>

                <div className="hero-v2__plans">
                  <div className="hero-v2__plansLabel">{isEn ? 'Choose your treatment:' : 'Chọn liệu trình:'}</div>
                  <div className="hero-v2__planList">
                    {heroPlans.map((p) => (
                      <button
                        key={p.key}
                        type="button"
                        className={`hero-v2__plan ${selectedPlan === p.key ? 'is-selected' : ''}`}
                        onClick={() => setSelectedPlan(p.key)}
                        aria-pressed={selectedPlan === p.key}
                      >
                        <div className="hero-v2__planMain">
                          <div className="hero-v2__planTitle">{p.title}</div>
                          {p.sub ? <div className="hero-v2__planSub">{p.sub}</div> : null}
                          <div className="hero-v2__planPriceRow">
                            {p.oldPrice ? <span className="hero-v2__planOld">{p.oldPrice}</span> : null}
                            <span className="hero-v2__planPrice">{p.price}</span>
                          </div>
                        </div>
                        <div className="hero-v2__planImgs" aria-hidden="true">
                          <img src={p.imgLeft} alt="" />
                          {p.imgRight && (
                            <>
                              <span className="hero-v2__planPlus">+</span>
                              <img src={p.imgRight} alt="" />
                            </>
                          )}
                        </div>
                      </button>
                    ))}
                  </div>

                  <button type="button" className="hero-v2__cta" onClick={openBooking}>
                    {isEn ? 'Book a consultation now' : 'Đặt lịch tư vấn ngay'}
                  </button>
                </div>
              </div>

              {/* Right */}
              <div className="hero-v2__right">
                <div className="hero-v2__collage">
                  <div className="hero-v2__collageCell">
                    <img src={HERO_V2.thumbs[heroImgIdx]} alt="" />
                  </div>
                </div>

                <div className="hero-v2__thumbRow">
                  <button
                    className="hero-v2__thumbNav"
                    type="button"
                    aria-label="Prev"
                    onClick={() => setHeroImgIdx((p) => (p - 1 + HERO_V2.thumbs.length) % HERO_V2.thumbs.length)}
                  >
                    ‹
                  </button>

                  <div className="hero-v2__thumbs" aria-label="Thư viện ảnh">
                    {HERO_V2.thumbs.map((src, i) => (
                      <div
                        key={src + i}
                        className={`hero-v2__thumb ${i === heroImgIdx ? 'is-active' : ''}`}
                        onClick={() => setHeroImgIdx(i)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={src} alt="" />
                      </div>
                    ))}
                  </div>

                  <button
                    className="hero-v2__thumbNav"
                    type="button"
                    aria-label="Next"
                    onClick={() => setHeroImgIdx((p) => (p + 1) % HERO_V2.thumbs.length)}
                  >
                    ›
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* ═══════════════════════════
          3b. KIT SHOWCASE — 2 banner + 4 khối (như hình mẫu 2)
      ═══════════════════════════ */}
      <section className="section section-kit-showcase sr">
        <div className="container">
          <div className="kit-showcase-desktop">
            <div className="kit-showcase-banners">
              {kitBanners.map((b) => (
                <div key={b.src} className="kit-showcase-bannerCell">
                  <img src={b.src} alt={b.alt} className="kit-showcase-bannerImg" />
                </div>
              ))}
            </div>

            <div className="kit-showcase-blocks">
              {kitBlocks.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={`kit-showcase-block ${selectedKit === item.key ? 'is-selected' : ''}`}
                  onClick={() => setSelectedKit(item.key)}
                  aria-pressed={selectedKit === item.key}
                  aria-label={item.label}
                >
                  <img src={item.img} alt={item.label} className="kit-showcase-blockImg" />
                </button>
              ))}
            </div>
          </div>

          <div
            className="kit-showcase-mobile"
            role="region"
            aria-roledescription="carousel"
            aria-label={isEn ? 'Kit showcase' : 'Bộ kit sản phẩm'}
          >
            <div className="kit-showcase-m-viewport">
              {kitCarouselIdx < kitBanners.length ? (
                <img
                  src={kitBanners[kitCarouselIdx].src}
                  alt={kitBanners[kitCarouselIdx].alt}
                  className="kit-showcase-m-img"
                  draggable={false}
                />
              ) : mobKitBlock ? (
                <button
                  type="button"
                  className={`kit-showcase-m-block ${selectedKit === mobKitBlock.key ? 'is-selected' : ''}`}
                  onClick={() => setSelectedKit(mobKitBlock.key)}
                  aria-pressed={selectedKit === mobKitBlock.key}
                  aria-label={mobKitBlock.label}
                >
                  <img src={mobKitBlock.img} alt="" className="kit-showcase-m-img" />
                </button>
              ) : null}
            </div>

            <div className="kit-showcase-m-controls">
              <button
                type="button"
                className="kit-showcase-m-arrow kit-showcase-m-arrow--prev"
                onClick={() => applyKitSlide(kitCarouselIdx - 1)}
                aria-label={isEn ? 'Previous slide' : 'Ảnh trước'}
              >
                <ChevronLeft size={22} strokeWidth={2.4} color="#ffffff" aria-hidden />
              </button>
              <div className="kit-showcase-m-dots" role="tablist" aria-label={isEn ? 'Slides' : 'Các ảnh'}>
                {Array.from({ length: kitSlideCount }, (_, i) => (
                  <button
                    key={i}
                    type="button"
                    role="tab"
                    aria-selected={i === kitCarouselIdx}
                    className={`kit-showcase-m-dot ${i === kitCarouselIdx ? 'is-active' : ''}`}
                    onClick={() => applyKitSlide(i)}
                    aria-label={isEn ? `Slide ${i + 1}` : `Ảnh ${i + 1}`}
                  />
                ))}
              </div>
              <button
                type="button"
                className="kit-showcase-m-arrow kit-showcase-m-arrow--next"
                onClick={() => applyKitSlide(kitCarouselIdx + 1)}
                aria-label={isEn ? 'Next slide' : 'Ảnh sau'}
              >
                <ChevronRight size={22} strokeWidth={2.4} color="#ffffff" aria-hidden />
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* ═══════════════════════════
          5. PRESS SECTION
      ═══════════════════════════ */}
      <section className="section section-press sr">
        <div className="container">
          <h2 className="press-rot-title">
            {isEn ? 'What do famous magazines say about microneedling?' : 'Tạp chí nổi tiếng nói gì về lăn kim?'}
          </h2>
          <div className="press-rot-quoteWrap">
            <p className="press-rot-quote">
              &ldquo;{pressItems[pressIdx].quote}&rdquo;
            </p>
          </div>
          <div
            className="press-rot-logos"
            role="tablist"
            aria-label={isEn ? 'Review sources' : 'Nguồn đánh giá'}
          >
            {pressItems.map((item, idx) => (
              <button
                key={item.key}
                type="button"
                className={`press-rot-logo ${idx === pressIdx ? 'is-active' : ''}`}
                onClick={() => setPressIdx(idx)}
                aria-pressed={idx === pressIdx}
              >
                <img
                  src={item.logoSrc}
                  alt={item.key}
                  className="press-rot-logo__img"
                />
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5b. SO SÁNH 3 CỘT (thay bảng 4 cột cũ)
      ═══════════════════════════ */}
      <section className="section section-compare sr">
        <div className="container">
          <h2 className="compare-v2-title">{compareV2.title}</h2>

          <div className="compare-v2-card">
            <div className="compare-v2-layout">
              <div className="compare-v2-left">
                {compareV2.rows.map((row) => (
                  <div key={row.label} className="compare-v2-leftRow">
                    {row.label}
                  </div>
                ))}
              </div>

              <div className="compare-v2-center">
                <div className="compare-v2-centerHead">
                  <div className="compare-v2-centerIconCircle" aria-hidden="true">
                    <img src={compareV2.rollerImg} alt="" />
                  </div>
                  <div className="compare-v2-centerHeadText">
                    {compareV2.auraHead}
                  </div>
                </div>
                <div className="compare-v2-pillList compare-v2-pillList--aura">
                  {compareV2.rows.map((row) => (
                    <div key={row.label} className="compare-v2-pill compare-v2-pill--aura">
                      {row.aura}
                    </div>
                  ))}
                </div>
              </div>

              <div className="compare-v2-right">
                <div className="compare-v2-rightHeadText">
                  {compareV2.cosHead}
                </div>
                <div className="compare-v2-pillList compare-v2-pillList--cos">
                  {compareV2.rows.map((row) => (
                    <div key={row.label} className="compare-v2-pill compare-v2-pill--cos">
                      {row.cos}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5d. 5 LÝ DO TIN DÙNG
      ═══════════════════════════ */}
      <section className="section section-reasons sr">
        <div className="container">
          <h2 className="reasons-title">
            {t('reasons.title')} {t('reasons.titleSub')} <em>{t('reasons.titleBrand')}</em>
          </h2>
          <div className="reasons-grid">
            <div className="reason-card">
              <span className="reason-icon"><TrendingUp size={48} strokeWidth={1.8} /></span>
              <p className="reason-desc">{t('reasons.reason1Full')}</p>
            </div>
            <div className="reason-card">
              <span className="reason-icon"><Waves size={48} strokeWidth={1.8} /></span>
              <p className="reason-desc">{t('reasons.reason2Full')}</p>
            </div>
            <div className="reason-card">
              <span className="reason-icon"><Clock3 size={48} strokeWidth={1.8} /></span>
              <p className="reason-desc">{t('reasons.reason3Full')}</p>
            </div>
            <div className="reason-card">
              <span className="reason-icon"><Sparkles size={48} strokeWidth={1.8} /></span>
              <p className="reason-desc">{t('reasons.reason4Full')}</p>
            </div>
            <div className="reason-card">
              <span className="reason-icon"><PhoneCall size={48} strokeWidth={1.8} /></span>
              <p className="reason-desc">{t('reasons.reason5Full')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5e. CƠ CHẾ VI TỔN THƯƠNG
      ═══════════════════════════ */}
      <section className="section section-mechanism">
        <div className="container mechanism-layout">

          {/* Left: content */}
          <div className="mechanism-content">
            <h2 className="mechanism-title">
              {isEn ? 'AuraGlow reaches where serums & moisturizers can’t...' : 'AuraGlow chạm tới nơi mà serum, kem dưỡng không thể chạm tới...'}
            </h2>
            <p className="mechanism-text">
              {isEn ? (
                <>
                  Ultra-fine needles made from medical-grade materials, with a 0.5mm length, penetrate the skin surface to create controlled “micro-injuries”. These nearly invisible micro-points act like guided pathways, helping nutrients penetrate deep into the skin—exactly where it needs repair and recovery. That’s why your serum and moisturizer work faster and better.
                </>
              ) : (
                <>
                  Những đầu kim siêu nhỏ, được làm từ chất liệu chuyên dụng trong y tế, với độ dài 0.5mm sẽ xuyên qua bề mặt da để tạo ra những "vi tổn thương" có kiểm soát. Các vi điểm gần như vô hình trên da sẽ đưa dưỡng chất thẩm thấu vào sâu trong da, đến nơi da cần được sửa chữa và phục hồi. Nhờ vậy mà serum, kem dưỡng bạn đang dùng mang lại hiệu quả nhanh hơn, tốt hơn.
                </>
              )}
            </p>
            <p className="mechanism-text">
              {isEn ? (
                <>
                  This process also stimulates the skin to produce more collagen and new cells, helping regenerate and restore skin structure. As a result, it noticeably reduces the appearance of melasma and wrinkles, leaving skin smooth, firm, and brighter.
                </>
              ) : (
                <>
                  Quá trình này cũng kích thích làn da sản sinh ra nhiều collagen và tế bào mới hơn, giúp tái tạo và phục hồi cấu trúc da.
                  Từ đó, giảm rõ rệt sự xuất hiện của nám sạm và nếp nhăn, dưỡng da căng mịn, trắng hồng.
                </>
              )}
            </p>
          </div>

          {/* Right: video */}
          <div className="mechanism-video">
            <video
              src="https://res.cloudinary.com/dzqgh7xfd/video/upload/v1775709719/3d-lan-kim_rjtxw7.mov"
              autoPlay
              loop
              muted
              playsInline
              poster="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774674433/aura_lsgxme.png"
            />
            <div className="mechanism-video-label">{t('mechanism.videoLabel')}</div>
          </div>

        </div>
      </section>

      {/* ═══════════════════════════
          5f. FEEDBACK KHÁCH HÀNG
      ═══════════════════════════ */}
      <section className="section section-feedback-v2 sr">
        <div className="container">
          <div className="feedback-v2-layout">
            <div className="feedback-v2-left">
              <div className="feedback-v2-imgCard">
                <img
                  src={FEEDBACK_V2_SLIDES[feedbackIdx]}
                  alt="Khách hàng chia sẻ"
                  className="feedback-v2-img"
                  decoding="async"
                  loading="eager"
                />
              </div>

              <div className="feedback-v2-dots" aria-label="Chọn slide">
                {FEEDBACK_V2_SLIDES.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`feedback-v2-dot ${i === feedbackIdx ? 'is-active' : ''}`}
                    onClick={() => setFeedbackIdx(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            <div className="feedback-v2-right">
              <h2 className="feedback-v2-title">
                {isEn ? 'Proven through customers’ hands-on experience' : 'Hiệu quả được chứng minh bằng trải nghiệm của khách hàng'}
              </h2>
              <p className="feedback-v2-subtitle">
                {isEn
                  ? 'Works from the very first use. Depending on the skin condition, customers will see noticeable changes after a few weeks.'
                  : 'Work ngay lần đầu. Tùy thuộc vào tình trạng da, khách hàng sẽ thấy sự thay đổi rõ rệt sau vài tuần'}
              </p>
              <ul className="feedback-v2-stats">
                {feedbackStats.map((item) => (
                  <li key={item.percent} className="feedback-v2-stat">
                    <span
                      className="feedback-v2-percent"
                      style={{ '--p': parseInt(item.percent, 10) }}
                    >
                      <span>{item.percent}</span>
                    </span>
                    <span className="feedback-v2-statText">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5g. KHỐI VIDEO BÁC SĨ (thêm mới)
      ═══════════════════════════ */}
      <section className="section section-consult-block sr">
        <div className="container">
          <div className="consult-block-wrap">
            <div className="consult-block-text">
              <ShieldCheck size={22} className="consult-block-icon" />
              <span>{isEn ? 'Trusted by dermatologists and recommended' : 'Được các bác sĩ da liễu tin tưởng và khuyến dùng'}</span>
            </div>

            {/* Desktop: main + 3 thumbs */}
            <div className="consult-block-desktop">
              <div className="consult-block-media">
                <LazyYouTube
                  videoId="6rYLlwK-oxg"
                  className="consult-block-img consult-block-video"
                  title="Video bác sĩ"
                />
              </div>
              <div className="consult-block-thumbs" aria-label="Các video bác sĩ khác">
                <LazyYouTube videoId="zU3H_2PIt20" className="consult-block-thumb consult-block-video" title="Video bác sĩ" />
                <LazyYouTube videoId="Ec9nhFp52kw" className="consult-block-thumb consult-block-video" title="Video bác sĩ" />
                <LazyYouTube videoId="mPujBb-7WeU" className="consult-block-thumb consult-block-video" title="Video bác sĩ" />
              </div>
            </div>

            {/* Mobile: main video + selectable thumbs */}
            <div className="consult-block-mobile">
              <LazyYouTube
                videoId={['6rYLlwK-oxg', 'zU3H_2PIt20', 'Ec9nhFp52kw', 'mPujBb-7WeU'][doctorVideoIdx]}
                className="consult-block-main-video"
                title="Video bác sĩ"
              />
              <div className="consult-block-mobile-thumbs" role="tablist" aria-label={isEn ? 'Choose video' : 'Chọn video'}>
                {['6rYLlwK-oxg', 'zU3H_2PIt20', 'Ec9nhFp52kw', 'mPujBb-7WeU'].map((id, i) => (
                  <button
                    key={id}
                    type="button"
                    role="tab"
                    aria-selected={i === doctorVideoIdx}
                    className={`consult-mobile-thumb ${i === doctorVideoIdx ? 'is-active' : ''}`}
                    onClick={() => setDoctorVideoIdx(i)}
                    aria-label={isEn ? `Play video ${i + 1}` : `Xem video ${i + 1}`}
                  >
                    <img
                      src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
                      alt={`Video ${i + 1}`}
                      loading="lazy"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          Feedback blocks (như ảnh mẫu)
      ═══════════════════════════ */}
      <section className="section section-feedback-blocks sr">
        <div className="container">
          <div className="feedback-blocks-shell">
            {feedbackBlocksMobile ? (
              <div
                className="feedback-blocks-grid feedback-blocks-grid--mobileOne"
                aria-label={isEn ? 'Customer feedback' : 'Feedback khách hàng'}
              >
                <div className="feedback-blocks-card">
                  <img
                    src={FEEDBACK_IMGS[feedbackMobileIdx]}
                    alt={isEn ? 'Customer feedback' : 'Feedback khách hàng'}
                    className="feedback-blocks-img"
                    decoding="sync"
                  />
                </div>
              </div>
            ) : (
              <div className="feedback-blocks-grid" aria-label="Feedback khách hàng">
                {Array.from({ length: FEEDBACK_CARDS_PER_PAGE }).map((_, i) => {
                  const src =
                    FEEDBACK_IMGS[(feedbackCardsPage * FEEDBACK_CARDS_PER_PAGE + i) % FEEDBACK_IMGS_LEN];
                  return (
                    <div key={`fb-desktop-slot-${i}`} className="feedback-blocks-card">
                      <img
                        src={src}
                        alt="Feedback khách hàng"
                        className="feedback-blocks-img"
                        decoding="async"
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="feedback-blocks-nav" aria-label="Điều hướng feedback">
            <button
              type="button"
              className="feedback-blocks-arrow"
              aria-label="Trước"
              onClick={() =>
                feedbackBlocksMobile
                  ? setFeedbackMobileIdx((p) => (p - 1 + FEEDBACK_IMGS_LEN) % FEEDBACK_IMGS_LEN)
                  : setFeedbackCardsPage(
                    (p) => (p - 1 + FEEDBACK_CARDS_PAGE_COUNT) % FEEDBACK_CARDS_PAGE_COUNT
                  )
              }
            >
              <ChevronLeft size={14} />
            </button>

            <div className="feedback-blocks-dots" aria-label="Chọn trang">
              {Array.from({
                length: feedbackBlocksMobile ? FEEDBACK_IMGS_LEN : FEEDBACK_CARDS_PAGE_COUNT,
              }).map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`feedback-blocks-dot ${(feedbackBlocksMobile ? i === feedbackMobileIdx : i === feedbackCardsPage)
                    ? 'is-active'
                    : ''
                    }`}
                  aria-label={`Trang ${i + 1}`}
                  onClick={() =>
                    feedbackBlocksMobile ? setFeedbackMobileIdx(i) : setFeedbackCardsPage(i)
                  }
                />
              ))}
            </div>

            <button
              type="button"
              className="feedback-blocks-arrow feedback-blocks-arrow--right"
              aria-label="Sau"
              onClick={() =>
                feedbackBlocksMobile
                  ? setFeedbackMobileIdx((p) => (p + 1) % FEEDBACK_IMGS_LEN)
                  : setFeedbackCardsPage((p) => (p + 1) % FEEDBACK_CARDS_PAGE_COUNT)
              }
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5h. KHÁCH HÀNG TẠI NHÀ
      ═══════════════════════════ */}
      <section className="section section-customer-videos sr">
        <div className="container customer-videos-wrap" style={{ maxWidth: '1440px' }}>
          <h2 className="customer-videos-title">
            {isEn ? 'Customers using AuraGlow dermaroller at home' : 'Khách hàng thực hiện lăn kim AuraGlow tại nhà'}
          </h2>

          <div className="customer-videos-desktop">
            <div className="customer-videos-grid">
              {CUSTOMER_HOME_VIDEOS.map((id) => (
                <LazyYouTube
                  key={id}
                  videoId={id}
                  className="customer-video-item"
                  title="Video khách hàng"
                />
              ))}
            </div>
          </div>

          <div
            className="customer-videos-mobile"
            role="region"
            aria-label={isEn ? 'Customer videos' : 'Video khách hàng'}
          >
            <LazyYouTube
              className="customer-video-main"
              videoId={CUSTOMER_HOME_VIDEOS[customerVideoIdx]}
              title="Video khách hàng"
            />
            <div className="customer-videos-thumbs" role="tablist" aria-label={isEn ? 'Choose video' : 'Chọn video'}>
              {CUSTOMER_HOME_VIDEOS.map((id, i) => (
                <button
                  key={id}
                  type="button"
                  role="tab"
                  aria-selected={i === customerVideoIdx}
                  className={`customer-video-thumb ${i === customerVideoIdx ? 'is-active' : ''}`}
                  onClick={() => setCustomerVideoIdx(i)}
                  aria-label={isEn ? `Play video ${i + 1}` : `Xem video ${i + 1}`}
                >
                  <img
                    src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
                    alt={`Video ${i + 1}`}
                    loading="lazy"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          Khối thông tin thời gian + Video hướng dẫn
      ═══════════════════════════ */}
      <section className="section section-weekly-info sr">
        <div className="container">
          <h2 className="weekly-info-text">
            {isEn ? 'Simple, quick—only 7 minutes per week' : 'Đơn giản, nhanh chóng, chỉ mất 7 phút mỗi tuần'}
          </h2>

          <div className="weekly-info-videos weekly-info-videos--single">
            <div className="weekly-info-video-card">
              <LazyYouTube
                videoId="kVjyDKk8BPE"
                className="weekly-info-video-item"
                title={isEn ? 'Product Demo' : 'Mẫu quay sản phẩm'}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-weekly-compare sr">
        <div className="container">
          <h2 style={{ textAlign: 'center', fontFamily: 'var(--font-heading)', fontSize: '38px', fontWeight: '500', color: '#111', marginBottom: '48px' }}>
            {isEn ? 'Superior method for beauty, skin rejuvenation' : 'Phương pháp vượt trội để làm đẹp, trẻ hóa da'}
          </h2>
          <div className="weekly-compare-table" aria-label="So sánh hiệu quả">
            <div className="weekly-compare-grid">
              {/* Header row */}
              <div className="weekly-compare-cell weekly-compare-cell--labelHead" />

              <div className="weekly-compare-cell weekly-compare-cell--head">
                <div className="weekly-compare-header">
                  <div className="weekly-compare-iconWrap">
                    <img src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671790/normal_mhs649.jpg" alt="Img sản phẩm thông thường" />
                  </div>
                  <div className="weekly-compare-headerTitle">
                    {isEn ? 'Regular Skincare' : 'Mỹ Phẩm Thông Thường'}
                  </div>
                </div>
              </div>

              <div className="weekly-compare-cell weekly-compare-cell--head">
                <div className="weekly-compare-header">
                  <div className="weekly-compare-iconWrap">
                    <img src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671790/massage_s8udb4.jpg" alt="lăn kim tại spa" />
                  </div>
                  <div className="weekly-compare-headerTitle">
                    {isEn ? 'Microneedling at a Spa' : 'Lăn Kim Tại Spa'}
                  </div>
                </div>
              </div>

              <div className="weekly-compare-cell weekly-compare-cell--head weekly-compare-cell--pinkHead">
                <div className="weekly-compare-header">
                  <div className="weekly-compare-iconWrap weekly-compare-iconWrap--pink">
                    <img src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671800/type1_i6lhuy.jpg" alt="" />
                  </div>
                  <div className="weekly-compare-headerTitle weekly-compare-headerTitle--pink">
                    {isEn ? 'Home Microneedling with AuraGlow' : 'Lăn Kim Tại Nhà Với AuraGlow'}
                  </div>
                </div>
              </div>

              {/* Row 1 */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">
                {isEn ? 'Nutrient Absorption' : 'Khả Năng Thẩm Thấu Dưỡng Chất'}
              </div>
              <div className="weekly-compare-cell">
                {isEn ? 'Limited by the skin barrier (only ~10%)' : 'Hạn chế, chỉ ~10%'}
              </div>
              <div className="weekly-compare-cell">
                {isEn ? 'High thanks to micro-injuries that create absorption pathways' : 'Cao'}
              </div>
              <div className="weekly-compare-cell weekly-compare-cell--pink">
                {isEn ? 'High: 0.5mm micro-needles + deep mineral infusion' : 'Cao, lên đến 98%'}
              </div>

              {/* Row 2 */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">{isEn ? 'Effectiveness' : 'Hiệu Quả'}</div>
              <div className="weekly-compare-cell">
                {isEn ? 'Slow—depends on skin type and evenness' : 'Chậm, tối thiểu 3-5 tháng'}
              </div>
              <div className="weekly-compare-cell">
                {isEn ? 'Noticeable improvement after 3–6 sessions' : 'Cải thiện sau 3 - 6 buổi'}
              </div>
              <div className="weekly-compare-cell weekly-compare-cell--pink">
                {isEn ? 'Visible in 2–4 weeks; more even tone, smoother, and firmer after a few sessions' : 'Thấy rõ sau 2 - 4 tuần, da đều màu, mịn và căng hơn'}
              </div>

              {/* Row 3 */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">{isEn ? 'Cost' : 'Chi Phí'}</div>
              <div className="weekly-compare-cell">
                {isEn ? 'Moderate, but can be costly long-term if results are poor' : 'Vừa phải, nhưng sẽ tốn kém nếu không hiệu quả'}
              </div>
              <div className="weekly-compare-cell">{isEn ? 'High ($100–$300 per session)' : 'Cao (100$ - 300$/1 buổi)'}</div>
              <div className="weekly-compare-cell weekly-compare-cell--pink">
                {isEn ? 'More affordable—about $50 per week' : 'Tiết kiệm hơn, chỉ khoảng 50$/1 tuần'}
              </div>

              {/* Row 4 */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">{isEn ? 'Convenience' : 'Tính Tiện Lợi'}</div>
              <div className="weekly-compare-cell">{isEn ? 'Easy to use daily' : 'Dễ sử dụng hàng ngày'}</div>
              <div className="weekly-compare-cell">{isEn ? 'Need to go to the spa, book appointments, travel' : 'Phải đến spa, đặt lịch, di chuyển'}</div>
              <div className="weekly-compare-cell weekly-compare-cell--pink">
                {isEn ? 'Very convenient—only 5–10 minutes at home each week' : 'Rất tiện, chỉ cần 5–10 phút tại nhà mỗi tuần'}
              </div>

              {/* Row 5 */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">{isEn ? 'Safety' : 'Độ An Toàn'}</div>
              <div className="weekly-compare-cell">{isEn ? 'Depends on product quality' : 'Phụ thuộc vào chất lượng sản phẩm'}</div>
              <div className="weekly-compare-cell">
                {isEn ? 'Risk of infection if the spa doesn’t ensure hygiene' : 'Có nguy cơ nhiễm trùng nếu spa không đảm bảo vô trùng'}
              </div>
              <div className="weekly-compare-cell weekly-compare-cell--pink">
                {isEn ? 'Highly safe—medical-grade material, used for you only' : 'An toàn cao – kim lăn chất liệu chuẩn y tế'}
              </div>

              {/* Row 6 (ô cuối: bo 2 góc dưới) */}
              <div className="weekly-compare-cell weekly-compare-cell--rowLabel">
                {isEn ? 'Accompanying Serum/Nutrients' : 'Serum/Dưỡng Chất Đi Kèm'}
              </div>
              <div className="weekly-compare-cell">
                {isEn ? 'Optional—may be mischosen or less effective' : 'Tùy chọn, dễ sai loại da hoặc thiếu hoạt chất'}
              </div>
              <div className="weekly-compare-cell">
                {isEn ? 'Spa-chosen—can be inconsistent or lower quality' : 'Spa chọn – đôi khi không rõ nguồn gốc'}
              </div>
              <div className="weekly-compare-cell weekly-compare-cell--pink weekly-compare-cell--pinkLast">
                {isEn
                  ? 'Exclusive formula—thoroughly researched for melasma-dark spots and anti-aging'
                  : 'Tinh chất độc quyền, được nghiên cứu kỹ lưỡng - đặc trị da nám sạm, lão hóa'}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          Serum details (như hình mẫu)
      ═══════════════════════════ */}
      <section className="section section-serum-details sr">
        <div className="container serum-details-wrap">
          <h2 className="serum-details-title">
            {isEn ? 'Two specialized serums in the AuraGlow microneedling kit' : 'Hai loại serum chuyên biệt trong bộ lăn kim AuraGlow'}
          </h2>

          <div className="serum-mobile-stack" aria-label={isEn ? 'Serum details' : 'Chi tiết từng serum'}>
            <article className="serum-m-card">
              <header className="serum-m-header">
                <div className="serum-bottleWrap serum-m-bottleWrap">
                  <img
                    src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671825/anti-aging_juv0tq.png"
                    alt="Serum Trẻ Hóa"
                    className="serum-bottle"
                  />
                </div>
                <div className="serum-pill serum-m-pill">
                  {isEn ? 'Anti-Aging Serum (Anti-Aging)' : 'Serum Trẻ Hóa (Anti-Aging)'}
                </div>
              </header>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Main benefits' : 'Công dụng chính'}</div>
                <p className="serum-desc serum-m-text">
                  {isEn
                    ? 'Reduces wrinkles, stimulates collagen production, brightens skin, and fades dark spots'
                    : 'Giảm nếp nhăn, kích thích sản sinh collagen, dưỡng trắng, làm mờ thâm nám'}
                </p>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Key active ingredients' : 'Hoạt chất chính'}</div>
                <ul className="serum-list serum-m-list">
                  <li>Peptide</li>
                  <li>Niacinamide</li>
                  <li>{isEn ? 'Stem cells' : 'Tế bào gốc'}</li>
                  <li>{isEn ? 'Vitamin C derivative' : 'Vitamin C dẫn xuất'}</li>
                  <li>EGF</li>
                </ul>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Effect after 2–4 weeks' : 'Hiệu quả sau 2–4 tuần'}</div>
                <p className="serum-foot serum-m-text">
                  {isEn
                    ? 'Skin feels firmer, reduces wrinkles on forehead/corners of eyes, brighter skin, clears melasma'
                    : 'Da săn chắc hơn, giảm nhăn vùng trán/khóe mắt, da sáng hơn, mờ nám'}
                </p>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">
                  {isEn ? 'Frequency with AuraGlow' : 'Tần suất dùng với lăn kim AuraGlow'}
                </div>
                <p className="serum-foot-extra serum-m-text">
                  {isEn
                    ? '1-2 times/week, combine with first microneedling'
                    : '1–2 lần/tuần, kết hợp khi lăn kim đầu'}
                </p>
              </section>
            </article>

            <article className="serum-m-card">
              <header className="serum-m-header">
                <div className="serum-bottleWrap serum-m-bottleWrap">
                  <img
                    src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671814/white_tea_g50ypl.png"
                    alt="Serum Phục Hồi"
                    className="serum-bottle"
                  />
                </div>
                <div className="serum-pill serum-m-pill">
                  {isEn ? 'Recovery Serum (White Tea)' : 'Serum Phục Hồi (White Tea)'}
                </div>
              </header>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Main benefits' : 'Công dụng chính'}</div>
                <p className="serum-desc serum-m-text">
                  {isEn
                    ? 'Deep hydration, repairing skin after microneedling, antioxidant support, and protection'
                    : 'Cấp ẩm sâu, phục hồi da sau lăn kim, chống oxy hóa, bảo vệ da'}
                </p>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Key active ingredients' : 'Hoạt chất chính'}</div>
                <ul className="serum-list serum-m-list">
                  <li>{isEn ? 'White Tea Extract' : 'Chiết xuất Trà Trắng'}</li>
                  <li>Panthenol (Vitamin B5)</li>
                  <li>{isEn ? 'Centella Asiatica Extract' : 'Chiết xuất Rau Má'}</li>
                  <li>Glycerin</li>
                </ul>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">{isEn ? 'Effect after 2–4 weeks' : 'Hiệu quả sau 2–4 tuần'}</div>
                <p className="serum-foot serum-m-text">
                  {isEn ? 'Softer, healthier skin, recovering the protective barrier' : 'Da mềm mịn hơn, khỏe mạnh hơn, phục hồi hàng rào bảo vệ da'}
                </p>
              </section>
              <section className="serum-m-section">
                <div className="serum-chip serum-chip--pink">
                  {isEn ? 'Frequency with AuraGlow' : 'Tần suất dùng với lăn kim AuraGlow'}
                </div>
                <p className="serum-foot-extra serum-m-text">
                  {isEn
                    ? 'Use after microneedling to soothe and recover skin'
                    : 'Dùng sau lăn kim để làm dịu, phục hồi da'}
                </p>
              </section>
            </article>
          </div>

          <div className="serum-grid-aligned" aria-label="Thông tin 2 loại serum">
            {/* Hàng 1: Chai và Tên */}
            <div className="s-cell-top">
              <div className="serum-bottleWrap">
                <img src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671825/anti-aging_juv0tq.png" alt="Serum Trẻ Hóa" className="serum-bottle" />
              </div>
              <div className="serum-pill">
                {isEn ? 'Anti-Aging Serum (Anti-Aging)' : 'Serum Trẻ Hóa (Anti-Aging)'}
              </div>
            </div>
            <div className="s-cell-top s-cell--empty"></div>
            <div className="s-cell-top">
              <div className="serum-bottleWrap">
                <img src="https://res.cloudinary.com/dzpcfivl6/image/upload/f_auto,q_auto/v1774671814/white_tea_g50ypl.png" alt="Serum Phục Hồi" className="serum-bottle" />
              </div>
              <div className="serum-pill">
                {isEn ? 'Recovery Serum (White Tea)' : 'Serum Phục Hồi (White Tea)'}
              </div>
            </div>

            {/* Hàng 2: Công dụng */}
            <div className="s-cell-text">
              <p className="serum-desc">
                {isEn
                  ? 'Reduces wrinkles, stimulates collagen production, brightens skin, and fades dark spots'
                  : 'Giảm nếp nhăn, kích thích sản sinh collagen, dưỡng trắng, làm mờ thâm nám'}
              </p>
            </div>
            <div className="s-cell-chip">
              <div className="serum-chip serum-chip--pink">{isEn ? 'Main benefits' : 'Công dụng chính'}</div>
            </div>
            <div className="s-cell-text">
              <p className="serum-desc">
                {isEn
                  ? 'Deep hydration, repairing skin after microneedling, antioxidant support, and protection'
                  : 'Cấp ẩm sâu, phục hồi da sau lăn kim, chống oxy hóa, bảo vệ da'}
              </p>
            </div>

            {/* Hàng 3: Hoạt chất */}
            <div className="s-cell-text">
              <ul className="serum-list">
                <li>Peptide</li>
                <li>Niacinamide</li>
                <li>{isEn ? 'Stem cells' : 'Tế bào gốc'}</li>
                <li>{isEn ? 'Vitamin C derivative' : 'Vitamin C dẫn xuất'}</li>
                <li>EGF</li>
              </ul>
            </div>
            <div className="s-cell-chip">
              <div className="serum-chip serum-chip--pink">{isEn ? 'Key active ingredients' : 'Hoạt chất chính'}</div>
            </div>
            <div className="s-cell-text">
              <ul className="serum-list">
                <li>{isEn ? 'White Tea Extract' : 'Chiết xuất Trà Trắng'}</li>
                <li>Panthenol (Vitamin B5)</li>
                <li>{isEn ? 'Centella Asiatica Extract' : 'Chiết xuất Rau Má'}</li>
                <li>Glycerin</li>
              </ul>
            </div>

            {/* Hàng 4: Hiệu quả */}
            <div className="s-cell-text">
              <p className="serum-foot">
                {isEn
                  ? 'Skin feels firmer, reduces wrinkles on forehead/corners of eyes, brighter skin, clears melasma'
                  : 'Da săn chắc hơn, giảm nhăn vùng trán/khóe mắt, da sáng hơn, mờ nám'}
              </p>
            </div>
            <div className="s-cell-chip">
              <div className="serum-chip serum-chip--pink">{isEn ? 'Effect after 2–4 weeks' : 'Hiệu quả sau 2–4 tuần'}</div>
            </div>
            <div className="s-cell-text">
              <p className="serum-foot">
                {isEn ? 'Softer, healthier skin, recovering the protective barrier' : 'Da mềm mịn hơn, khỏe mạnh hơn, phục hồi hàng rào bảo vệ da'}
              </p>
            </div>

            {/* Hàng 5: Tần suất */}
            <div className="s-cell-text">
              <p className="serum-foot-extra" style={{ margin: 0, textAlign: 'center', fontSize: '13px', color: '#111', fontFamily: 'var(--font-body)' }}>
                {isEn
                  ? '1-2 times/week, combine with first microneedling'
                  : '1–2 lần/tuần, kết hợp khi lăn kim đầu'}
              </p>
            </div>
            <div className="s-cell-chip">
              <div className="serum-chip serum-chip--pink">
                {isEn ? 'Frequency with AuraGlow' : 'Tần suất dùng với lăn kim AuraGlow'}
              </div>
            </div>
            <div className="s-cell-text">
              <p className="serum-foot-extra" style={{ margin: 0, textAlign: 'center', fontSize: '13px', color: '#111', fontFamily: 'var(--font-body)' }}>
                {isEn
                  ? 'Use after microneedling to soothe and recover skin'
                  : 'Dùng sau lăn kim để làm dịu, phục hồi da'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          Chọn liệu trình (như hình mẫu)
      ═══════════════════════════ */}
      <section className="section section-plan-choose sr">
        <div className="container plan-choose-wrap">
          <div className="plan-choose-grid">
            <div className="plan-choose-media">
              <img
                src="https://res.cloudinary.com/dzqgh7xfd/image/upload/f_auto,q_auto/v1775056111/Tk_bao_bi_moi_cu_ra7xx8.png"
                alt="AuraGlow Product"
                className="plan-choose-hero-img"
              />
            </div>

            <div className="plan-choose-panel">
              <h3 className="plan-choose-title">
                {isEn ? 'Click to choose a treatment plan' : 'Bấm để chọn liệu trình'}
              </h3>

              <div className="plan-choose-options" role="group" aria-label="Chọn liệu trình">
                <button
                  type="button"
                  className={`plan-choice ${selectedPlan === '3m' ? 'is-active' : ''}`}
                  aria-pressed={selectedPlan === '3m'}
                  onClick={() => setSelectedPlan('3m')}
                >
                  <div className="plan-choice-title">{isEn ? '3-Month Treatment' : 'Liệu trình 3 tháng'}</div>
                  <div className="plan-choice-sub">
                    {isEn ? '(Free 1 full-size 30ml anti-aging serum)' : '(Tặng 1 serum trẻ hóa fullsize 30ml)'}
                  </div>
                  <div className="plan-choice-prices">
                    <span className="plan-choice-old">$741</span>
                    <span className="plan-choice-new">$540</span>
                  </div>
                </button>

                <button
                  type="button"
                  className={`plan-choice ${selectedPlan === '2m' ? 'is-active' : ''}`}
                  aria-pressed={selectedPlan === '2m'}
                  onClick={() => setSelectedPlan('2m')}
                >
                  <div className="plan-choice-title">{isEn ? '2-Month Treatment' : 'Liệu trình 2 tháng'}</div>
                  <div className="plan-choice-sub">
                    {isEn ? '(Free 1 sleeping mask)' : '(Tặng 1 mặt nạ ngủ)'}
                  </div>
                  <div className="plan-choice-prices">
                    <span className="plan-choice-old">$494</span>
                    <span className="plan-choice-new">$360</span>
                  </div>
                </button>

                <button
                  type="button"
                  className={`plan-choice ${selectedPlan === '1m' ? 'is-active' : ''}`}
                  aria-pressed={selectedPlan === '1m'}
                  onClick={() => setSelectedPlan('1m')}
                >
                  <div className="plan-choice-title">{isEn ? '1-Month Treatment' : 'Liệu trình 1 tháng'}</div>
                  <div className="plan-choice-prices-only">$247</div>
                </button>
              </div>

              <button type="button" className="plan-choose-cta" onClick={openBooking}>
                {isEn ? 'Book a consultation now' : 'Đặt lịch tư vấn ngay'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          5h. CHỌN LIỆU TRÌNH
      ═══════════════════════════ */}
      {/* (Block CHỌN LIỆU TRÌNH đã được xóa theo yêu cầu) */}

      {/* ═══════════════════════════
          5i. FAQ
      ═══════════════════════════ */}
      <section className="section section-faq sr">
        <div className="container">
          <h2 className="faq-title">{isEn ? 'Your questions answered' : 'Giải đáp thắc mắc của bạn'}</h2>
          <div className="faq-list">
            {FAQ_KEYS.map((key, i) => (
              <FaqItem key={i} q={t(`faq.${key}`)} a={t(`faq.a${i + 1}`)} />
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════
          Khách hàng đánh giá (giao diện dạng review)
      ═══════════════════════════ */}
      <section className="section section-rb-reviews">
        <div className="container">
          <h2 className="rb-reviews-title">
            {isEn ? 'Customer Reviews' : 'Khách hàng đánh giá'}
          </h2>

          <div className="rb-reviews-list">
            {rbReviews.map((r, idx) => (
              <div key={idx} className="rb-review">
                <div className="rb-review-header">
                  {/* avatar placeholder*/}
                  <div
                    className="rb-avatar rb-avatar--placeholder"
                    aria-hidden="true"
                    style={{
                      backgroundImage: `url("${r.avatar || RB_AVATAR_URLS[idx % RB_AVATAR_URLS.length]}")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  />
                  <div className="rb-review-meta">
                    <div className="rb-username">{r.name}</div>
                    <div className="rb-stars rb-stars--pink">{"★★★★★".slice(0, r.stars)}</div>
                  </div>
                </div>

                {r.highlight ? (
                  <div className="rb-review-highlight">{r.highlight}</div>
                ) : null}
                <div className="rb-review-text">{r.text}</div>

                {r.afterTextThumb ? (
                  Array.isArray(r.afterTextThumb) ? (
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
                      {r.afterTextThumb.map((imgSrc, i) => (
                        <img
                          key={i}
                          src={imgSrc}
                          alt=""
                          className="rb-review-thumb"
                          aria-hidden="true"
                          style={{ margin: 0 }}
                        />
                      ))}
                    </div>
                  ) : (
                    <img
                      src={r.afterTextThumb}
                      alt=""
                      className="rb-review-thumb"
                      aria-hidden="true"
                    />
                  )
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* ═══════════════════════════
          BOOKING MODAL
      ═══════════════════════════ */}
      {showBooking && (
        <div className="booking-overlay" onClick={closeBooking}>
          <div className="booking-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="booking-close" onClick={closeBooking} aria-label="Close">
              <X size={22} />
            </button>

            {bookingSuccess ? (
              <div className="booking-success">
                <div className="booking-success-icon" aria-hidden="true">✓</div>
                <h3>{isEn ? 'Booking Confirmed!' : 'Đặt lịch thành công!'}</h3>
                <p>
                  {isEn
                    ? 'Thank you! We will contact you shortly to confirm your consultation.'
                    : 'Cảm ơn bạn! Chúng tôi sẽ liên hệ sớm để xác nhận lịch tư vấn.'}
                </p>
                <button type="button" className="booking-done-btn" onClick={closeBooking}>
                  {isEn ? 'Close' : 'Đóng'}
                </button>
              </div>
            ) : (
              <>
                <h3 className="booking-title">
                  {isEn ? 'Book a Consultation' : 'Đặt lịch tư vấn'}
                </h3>

                <form onSubmit={handleBookingSubmit} className="booking-form">
                  <div className="booking-field">
                    <label>{isEn ? 'Full Name' : 'Họ và tên'} *</label>
                    <input
                      type="text"
                      name="fullName"
                      value={bookingForm.fullName}
                      onChange={handleBookingChange}
                      required
                      placeholder={isEn ? 'Enter your full name' : 'Nhập họ và tên'}
                    />
                  </div>
                  <div className="booking-field">
                    <label>{isEn ? 'Phone Number' : 'Số điện thoại'} *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={bookingForm.phone}
                      onChange={handleBookingChange}
                      required
                      placeholder={isEn ? 'Enter your phone number' : 'Nhập số điện thoại'}
                    />
                  </div>
                  <div className="booking-field">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={bookingForm.email}
                      onChange={handleBookingChange}
                      required
                      placeholder={isEn ? 'Enter your email' : 'Nhập email'}
                    />
                  </div>
                  <div className="booking-field">
                    <label>{isEn ? 'Address' : 'Địa chỉ'}</label>
                    <input
                      type="text"
                      name="address"
                      value={bookingForm.address}
                      onChange={handleBookingChange}
                      placeholder={isEn ? 'Enter your address (optional)' : 'Nhập địa chỉ (không bắt buộc)'}
                    />
                  </div>

                  <button type="submit" className="booking-submit" disabled={bookingSubmitting}>
                    {bookingSubmitting
                      ? (isEn ? 'Submitting...' : 'Đang gửi...')
                      : (isEn ? 'Confirm Booking' : 'Xác nhận đặt lịch')}
                  </button>
                  {bookingError && <p className="booking-error">{bookingError}</p>}
                </form>
              </>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default Home;
